import { omit } from 'lodash';

import { User } from '@evidentid/tprm-portal-lib/models/user-management';

import { UserDataModel } from '../models/users/userDataModel.model';

export function convertUserDataToViewModel(user: UserDataModel): User {
    return {
        ...omit(user, [ 'avatar_url', 'email_verified', 'invite_email_timestamp', 'federated_connections' ]),
        avatarUrl: user.avatar_url,
        emailVerified: user.email_verified,
        inviteEmailTimestamp: user.invite_email_timestamp,
        // Defaulted here rather than at every reader: an older backend that omits the key means
        // "no federated identity visible", which is the same as an empty array and leaves roles
        // editable. Readers then never have to tell absent from empty.
        federatedConnections: user.federated_connections || [],
    };
}
